import { defaultProject, defaultCompany } from '../../constant/defaultData'

export default {
  // props: {
  //   company: { type: Object, default: () => ({}) },
  //   allEditStatus: { type: String, defalut: '' },
  //   cannotEdit: { type: Boolean, defalut: false },
  //   companyFiles: { type: Array, defalut: () => [] },
  // },
  data() {
    return {
      isEditing: false,
      projectInEdit: {},
      // 是否在职，在职true
      userInservice: true,
    }
  },
  watch: {
    allEditStatus(newValue, oldValue) {
      if (newValue === '编辑') {
        this.allEditing = true
        this.toEdit()
      } else if (newValue === '保存') {
        this.allEditing = false
        this.confirmEdit()
      } else if (newValue === '取消') {
        this.allEditing = false
        this.cancelEdit()
      }
    },
    isEditing(newValue, oldValue) {
      if (newValue) this.showDetail = true
    },
  },
  mounted() {
    this.userInservice = !['离职中', '已离职'].includes(app.user.状态)
  },
  methods: {
    async updateProject(param = {}) {
      if (Object.keys(param).length > 0) return
      try {
        await app.service('project').modify({
          id: this.project._id,
          param: param,
        })
        Object.assign(this.project, param)
      } catch (e) {
        this.$message.error(`修改失败:${e.msg}`)
      }
    },
    toEdit() {
      this.projectInEdit = {}
      this.fields.forEach(key => {
        const value =
          this.project[key] || (typeof defaultProject[key] === 'object' ? window._.cloneDeep(defaultProject[key]) : '')
        if (value && typeof value === 'object') {
          const newVal = JSON.parse(JSON.stringify(value))
          this.$set(this.projectInEdit, key, newVal)
        } else {
          this.$set(this.projectInEdit, key, value)
        }
      })
      this.isEditing = true
      this.$emit('toEdit', this.componentType)
    },
    openHistory(type) {
      this.$emit('openHistory', type)
    },
    cancelEdit() {
      this.isEditing = false
      this.$emit('cancelEdit', this.componentType)
    },
    async confirmEdit(notification) {
      if (!this.isEditing) return
      if (Object.keys(this.projectInEdit).length === 0) return
      try {
        await app.service('project').modify({
          id: this.project._id,
          param: this.projectInEdit,
        })
        Object.assign(this.project, this.projectInEdit)
        this.$emit('confirmEdit', { type: this.componentType, data: this.projectInEdit })
        this.$message.success(`修改成功`)
      } catch (e) {
        this.$message.error(`修改失败:${e.msg}`)
      }
      this.isEditing = false
    },
    filesFilter(type) {
      const files = this.companyFiles
      if (!type) return files
      return files.filter(val => val.type === type)
    },
    async preview(file) {
      const ref = app.root.$refs.cvPreview
      if (!ref) return
      await ref.getFile(file)
      ref.show()
    },
    getDate(val) {
      const year = new Date(val).getFullYear()
      const month = new Date(val).getMonth() + 1
      const data = new Date(val).getDate()
      return `${year}/${month}/${data}`
    },
    saveUnConfirm() {
      if (this.isEditing) this.confirmEdit()
    },
  },
}
